<template>
  <div>
    <ed-form
      :data="parent.formFilter"
      :config="config"
      :response="response"
      :itens="filterItems"
    >
      <!-- <div slot="form-footer"></div> -->
    </ed-form>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdModal from "common/modal";
import EdForm from "common/form";
import FormItems from "../_form/filtrar";

export default {
  name: "esocial-gerar-lote",
  mixins: [Rest],
  components: { EdModal, EdForm },
  props: {
    parent: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "parent.formFilter.id_empresa"() {
      this.config.disabled.id_fdt = this.parent.formFilter.id_empresa
        ? false
        : true;
      this.config.disabled.id_funcionario = this.parent.formFilter.id_empresa
        ? false
        : true;

      this.parent.formFilter.id_fdt = null;
      this.parent.formFilter.id_funcionario = null;

      this.getFdt();
      this.getFuncionario();
    },
    "parent.formData.layout"() {},
    "parent.formFilter.empresa_envio_automatico"(){
      this.config.disabled.id_empresa = this.parent.formFilter.empresa_envio_automatico
      this.parent.formFilter.id_tipo_status = []

      if(this.parent.formFilter.empresa_envio_automatico){
        this.parent.formFilter.id_empresa = null
        this.parent.formFilter.id_fdt = null
        this.parent.formFilter.id_funcionario = null
        this.parent.formFilter.id_tipo_status = [328,331,336,335,330]
      }
    }
  },

  data() {
    return {
      config: {
        tipo: [327],
        click: {
          id_empresa: this.getEmpresa,
          id_fdt: this.getFdt,
          id_funcionario: this.getFuncionario,
          mostrar: this.getMostrar,
          empresa_envio_automatico:null
        },
        loading: {
          id_empresa: false,
          id_fdt: false,
          id_funcionario: false,
          mostrar: false,
          empresa_envio_automatico:false,
        },
        list: {
          id_empresa: [],
          id_fdt: [],
          id_funcionario: [],
          mostrar: [],
          empresa_envio_automatico:[],
        },
        disabled: {
          id_fdt: true,
          id_funcionario: true,
          empresa_envio_automatico:false,
        },
        title:{
          model:'empresa_envio_automatico',
          empresa_envio_automatico:'Selecionar empresas com processamento automático dos lotes'
        },
        description:{
          empresa_envio_automatico:'Essa campo permite selecionar automaticamente as empresas que estão definidas para processamento automático dos lotes em Esocial > Configurações >  Processar Lote'
        }
      },
      response: {},
      filterItems: [],
    };
  },

  created() {},

  mounted() {
    this.filterItems = FormItems;

    this.getEmpresa();
    this.getMostrar();
  },

  methods: {
    getMostrar() {
      this.config.list.mostrar = [
        { id: 1, nome: "Apenas arquivos SEM XML gerado" },
        { id: 2, nome: "Apenas arquivos COM XML gerado" },
        { id: 3, nome: "Apenas arquivos SEM conflitos" },
        { id: 4, nome: "Apenas arquivos COM conflitos" },
      ];
    },

    getEmpresa(search) {
      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: search }).then((result) => {
        result = result[0];

        this.config.loading.id_empresa = false;

        if (result.status == 200) {
          this.config.list.id_empresa = result.data.data;
        }
      });
    },

    getFdt(search) {
      if (!this.parent.formFilter.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.parent.formFilter.id_empresa, {
        search: search,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_fdt = false;

        if (result.status == 200) {
          this.config.list.id_fdt = result.data.data;
        }
      });
    },

    getFuncionario: function (_search) {
      if (!this.parent.formFilter.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.parent.formFilter.id_empresa, {
        search: _search,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_funcionario = false;

        if (result.status == 200) {
          this.config.list.id_funcionario = result.data.data;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// filter.vue?4d86a143